import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Sidebar from './sidebar';
import Overlay from '../components/overlay';
import Header from './header';

class Dashboard extends Component {
  componentWillMount() {
    this.props.fetchMessage();
  }

  render() {    
    return (
      <div>
      <Overlay />
      <Sidebar />
      <Header />
      <div className="site-content">
        This is the dashboard page
      </div>
    </div>
    );
  }
}

export default connect(null, actions)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/dashboard.js